import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "regenerator-runtime/runtime.js";
import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_UPDATE_LOG_DETAIL',
        create: 'DEVICE_UPDATE_LOG_CREATE',
        update: 'DEVICE_UPDATE_LOG_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      },
      userInfo: {}
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.form.model.market_id = utils.cookies.get('market_id');

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    setting: function setting() {
      var _this2 = this;

      var h = this.$createElement;
      return [].concat(_toConsumableArray(this.mode === 'edit' ? [{
        prop: 'id',
        default: '',
        label: 'id',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.form.model.id,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_number',
        default: '',
        label: this.$t('device_number'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_number", $$v);
              }
            }
          });
        }
      }] : [].concat(_toConsumableArray(this.form.model.market_id == 0 ? [{
        prop: 'market_id',
        default: '',
        label: this.$t('market_id'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_market_id",
              "clearable": true,
              "custom": true
            },
            "on": {
              "change": _this2.onMarketChange
            },
            "model": {
              value: _this2.form.model.market_id,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "market_id", $$v);
              }
            }
          });
        }
      }] : []), [{
        prop: 'device_number',
        default: '',
        label: this.$t('device_number'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_device_number",
              "clearable": true,
              "custom": true
            },
            "model": {
              value: _this2.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_number", $$v);
              }
            }
          });
        }
      }])), [{
        prop: 'soft_url',
        default: '',
        label: 'soft_url',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this2.form.model.soft_url,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "soft_url", $$v);
              }
            }
          });
        }
      }, {
        prop: 'new_version',
        default: '',
        label: 'new_version',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this2.form.model.new_version,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "new_version", $$v);
              }
            }
          });
        }
      }, {
        prop: 'old_version',
        default: '',
        label: 'old_version',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this2.form.model.old_version,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "old_version", $$v);
              }
            }
          });
        }
      }, {
        prop: 'old_soft_url',
        default: '',
        label: 'old_soft_url',
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this2.form.model.old_soft_url,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "old_soft_url", $$v);
              }
            }
          });
        }
      }]);
    }
  },
  methods: {
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,user_name',
        path: 'list',
        label: 'user_name',
        value: 'id'
      }), this.loadDictOne({
        name: 'form_device_number',
        method: this.$api.DEVICE_ALL,
        fields: 'device_number,device_name',
        path: 'list',
        label: 'form_device_number',
        value: 'device_number'
      });
    },
    onMarketChange: function onMarketChange() {
      this.loadDictOne({
        name: 'form_device_number',
        method: this.$api.DEVICE_ALL,
        query: {
          'market_id': this.form.model.market_id
        },
        fields: 'device_number,device_name',
        path: 'list',
        label: 'form_device_number',
        value: 'device_number'
      });
    }
  }
};